import { motion } from "framer-motion";
import "../styles/Plans.css";
import { useCallback, useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import BASE_URL from "../BaseUrl";
export default function PlansPage({setActive, pagesOut}) {


  const [plans,setPlans] = useState([]);

  const fetchPlans = ()=>{
      axios.get(`${BASE_URL}/teacher/plans`,{withCredentials:true})
      .then((response)=>{
        setPlans(response.data);
      }).catch((error)=>{
        console.log(error);
      })
  }

    useEffect(()=>{
        setActive("خطط الاسعار");
        fetchPlans();
    },[]) 

  return (
    <div className="page-plans-container">
      <h1 className="text-3xl font-bold text-center mb-10 text-purple-700">
        اختر خطة اسعارك
      </h1>

      {/* Small Cards */}
      <div className="plans-container" dir="rtl">
        {plans.map((plan, i) => (
          // <motion.div
          //   key={plan.id}
          //   initial={{ opacity: 0, x: 70 }}
          //   animate={{ opacity: 1, x: 40 }}
          //   exit={{opacity:0, x:70}}
          //   transition={{ delay: i * 0.0001 }}
          // >
          // <div >
            <div className={`plan-card ${pagesOut.plansOut?"plans-out":"plans-in"}`}>
              <h2 className="text-lg font-bold text-purple-600 mb-2">
                {plan.name}
              </h2>
              <p className="text-gray-600 text-sm">📦 {plan.capacity} درس</p>
              <p style={{width:"130%"}} className="text-gray-600 text-sm">👨‍🎓 {plan.students} طالب</p>
              <p className="text-gray-600 text-sm">👩‍🏫 {plan.assistants} مساعد</p>

              <div className="prices">    
                
                <p className="text-xl font-bold text-green-600"
                style={{
                    fontSize:"larger",
                    fontWeight:"bolder"
                }}>ج.م{plan.price}</p>
                <p className="line-through text-gray-400 text-sm"
                style={{textDecoration:"line-through", fontSize:"small", paddingTop:"4px",marginTop:"-20px", fontWeight:"lighter"}}
                >ج.م{plan.oldPrice}</p>
              </div>

              
            </div>
          // </div> 
        ))}
      </div>
    </div>
  );
}
